import { Seo } from "@/components/Seo";
import { ErrorState } from "@/components/ErrorState";

export default function NotFoundPage() {
  return (
    <>
      <Seo
        title="Halaman tidak ditemukan"
        description="Halaman yang kamu cari tidak ditemukan di Nofina Movie."
      />
      <ErrorState
        title="Halaman tidak ditemukan"
        description="Halaman yang kamu cari tidak ada atau sudah dipindahkan."
        actionTo="/"
        actionLabel="Kembali ke Beranda"
      />
    </>
  );
}
